<script setup>
import { ref } from 'vue';
import { Plus } from 'lucide-vue-next';

const props = defineProps({
  /** Array of { q, a } */
  items: { type: Array, required: true },
  /** Allow several rows open at once */
  multiple: { type: Boolean, default: false },
  /** lines (hairline rules) or cards (each row a soft tile, no rules) */
  variant: { type: String, default: 'lines' },
});
const open = ref(new Set());
function toggle(i) {
  const s = new Set(props.multiple ? open.value : []);
  open.value.has(i) ? s.delete(i) : s.add(i);
  open.value = s;
}
</script>

<template>
  <div class="pd-acc" :class="`pd-acc--${variant}`">
    <div v-for="(it, i) in items" :key="i" class="pd-acc__item" :class="{ 'is-open': open.has(i) }">
      <h3 class="pd-acc__h">
        <button type="button" class="pd-acc__q" :aria-expanded="open.has(i)" @click="toggle(i)">
          <span class="pd-acc__n pd-num">{{ String(i + 1).padStart(2, '0') }}</span>
          <span class="pd-acc__qt">{{ it.q }}</span>
          <Plus class="pd-acc__plus" :size="22" :stroke-width="2.25" aria-hidden="true" />
        </button>
      </h3>
      <div class="pd-acc__a" :hidden="!open.has(i)"><p>{{ it.a }}</p></div>
    </div>
  </div>
</template>

<style scoped>
.pd-acc--lines .pd-acc__item { border-top: 1px solid var(--pd-line); }
.pd-acc--lines .pd-acc__item:last-child { border-bottom: 1px solid var(--pd-line); }
.pd-acc--cards { display: flex; flex-direction: column; gap: 10px; }
.pd-acc--cards .pd-acc__item { border-radius: var(--pd-r-md); background: var(--pd-white); transition: background-color var(--pd-med) var(--pd-ease), box-shadow var(--pd-med) var(--pd-ease); }
.pd-acc--cards .pd-acc__item.is-open { box-shadow: 0 1px 0 rgba(18, 18, 18, 0.03), 0 12px 32px rgba(18, 18, 18, 0.06); }
.pd-acc--cards .pd-acc__q { padding: 22px 24px; }
.pd-acc--cards .pd-acc__a { padding: 0 64px 24px 62px; }
.pd-acc__h { margin: 0; }
.pd-acc__q { display: flex; align-items: center; gap: 18px; width: 100%; padding: 22px 0; border: 0; background: none; text-align: left; cursor: pointer; }
.pd-acc__n { font-size: 0.75rem; font-weight: 800; color: var(--pd-orange-text); }
.pd-acc__qt { flex: 1; font-size: 1.125rem; font-weight: 800; letter-spacing: -0.02em; }
.pd-acc__plus { transition: transform var(--pd-med) var(--pd-ease); }
.is-open .pd-acc__plus { transform: rotate(45deg); }
.pd-acc__a { padding: 0 40px 24px 38px; color: var(--pd-muted); }
@media (max-width: 560px) {
  .pd-acc--cards .pd-acc__q { padding: 18px; gap: 14px; }
  .pd-acc--cards .pd-acc__a { padding: 0 18px 20px; }
}
</style>
